module.exports = __webpack_public_path__ + "static/media/defaultTopic.8f4a58c0.jpg";